export const SAVE_PARTY_DETAILS = "SAVE_PARTY_DETAILS"
export const SAVE_PARTY_DETAILS_SUCCESS = "SAVE_PARTY_DETAILS_SUCCESS"

export const GO_BUTTON_PARTY_DETAILS_LIST = 'GO_BUTTON_PARTY_DETAILS_LIST'
export const GO_BUTTON_PARTY_DETAILS_LIST_SUCCESS = 'GO_BUTTON_PARTY_DETAILS_LIST_SUCCESS'

export const PARTY_DETAILS_API_ERROR_ACTION = 'PARTY_DETAILS_API_ERROR_ACTION'